import { ButtonVariant, CoButton } from "components/CoButton";
import Tag from "components/Tag";
import path from "constants/path";
import { useResearchHubMode } from "features/ResearchHub/hooks/useResearchHubMode";
import {
  logAnnouncementBannerDismiss,
  logAnnouncementBannerResearchHubLink,
} from "helpers/services/mixpanel";
import { MixpanelActionSource } from "helpers/services/mixpanel/events";
import useLabels from "hooks/useLabels";
import Link from "next/link";
import { useRouter } from "next/router";
import { toast } from "react-toastify";
import { useResearchPaperUpload } from "./hooks/useResearchPaperUpload";

export const ResearchHubBanner = () => {
  const router = useRouter();
  const [labels] = useLabels("research-hub-banner");
  const [askPaperLabels] = useLabels("ask-paper-upload-new-paper-guide");
  const { dismissResearchHubBanner } = useResearchHubMode();

  const handleDismissResearchHubBanner = () => {
    dismissResearchHubBanner();
    logAnnouncementBannerDismiss();
  };

  const handleResearchHubLinkClick = () => {
    dismissResearchHubBanner();
    router.push(path.RESEARCH_HUB_UPLOADED);
    logAnnouncementBannerResearchHubLink();
  };

  const { triggerFileSelection, isUploading } = useResearchPaperUpload({
    onUploadTriggered: () => {
      dismissResearchHubBanner();
      router.push("/hub/uploaded");
    },
    onSuccess: () => {
      toast.success(askPaperLabels["toast-success"]);
    },
    onError: (errorMessage?: string) => {
      toast.error(errorMessage || askPaperLabels["toast-error"]);
    },
    actionSource: MixpanelActionSource.ResearchHubAnnouncementBanner,
  });

  return (
    <div className="pt-2 rounded-[16px] bg-bg-faint items-center justify-between gap-4 border border-border-base mb-4 pb-4">
      <div className="flex items-center justify-between gap-2 mb-1 pl-4 pr-1">
        <div className="flex items-center gap-2">
          <i className="icon-file-arrow-up text-lg text-fg-base" />
          <h2 className="text-base font-medium">{labels["title"]}</h2>
          <Tag label={labels["new-text"]} size="sm" />
        </div>

        <div className="flex justify-end">
          <CoButton
            variant={ButtonVariant.Flat}
            label={isUploading ? "Uploading..." : labels["upload"]}
            icon="icon-upload"
            size="sm"
            onClick={triggerFileSelection}
            disabled={isUploading}
            hideLabelResponsively
          />
          <CoButton
            variant={ButtonVariant.Flat}
            icon="icon-x"
            size="sm"
            onClick={handleDismissResearchHubBanner}
            aria-label="Close"
          />
        </div>
      </div>
      <div className="flex items-center gap-4 mt-1 pl-4 pr-4 ">
        <p className="text-fg-muted leading-5">
          {labels["subtitle"]}
          <Link
            href={path.RESEARCH_HUB_UPLOADED}
            className="underline"
            onClick={handleResearchHubLinkClick}
          >
            {labels["research-hub"]}
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default ResearchHubBanner;
